// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__sx4m7","colCheckbox":"styles_colCheckbox__1bm1f"};